// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var Matrix$ReactTemplate = require("./Matrix.bs.js");
var Game_model$ReactTemplate = require("./Game_model.bs.js");
var Js_array_plus$ReactTemplate = require("./Js_array_plus.bs.js");

function colorByState(state) {
  if (state) {
    return "#357720";
  } else {
    return "#bdbdbd";
  }
}

function reducer(state, action) {
  if (typeof action === "number") {
    switch (action) {
      case /* Init */0 :
          return {
                  inProgress: false,
                  fieldSize: state.fieldSize,
                  interval: state.interval,
                  cells: Js_array_plus$ReactTemplate.init_matrix(state.fieldSize, state.fieldSize, (function (param) {
                          if (Math.random() > 0.7) {
                            return /* Alive */1;
                          } else {
                            return /* Dead */0;
                          }
                        })),
                  generation: 0
                };
      case /* Clear */1 :
          return {
                  inProgress: false,
                  fieldSize: state.fieldSize,
                  interval: state.interval,
                  cells: Js_array_plus$ReactTemplate.make_matrix(state.fieldSize, state.fieldSize, /* Dead */0),
                  generation: 0
                };
      case /* Evolve */2 :
          return {
                  inProgress: state.inProgress,
                  fieldSize: state.fieldSize,
                  interval: state.interval,
                  cells: Game_model$ReactTemplate.next_generation(state.cells),
                  generation: state.generation + 1 | 0
                };
      
    }
  } else {
    switch (action.tag | 0) {
      case /* ToggleGame */0 :
          return {
                  inProgress: action[0],
                  fieldSize: state.fieldSize,
                  interval: state.interval,
                  cells: state.cells,
                  generation: state.generation
                };
      case /* ToggleCell */1 :
          return {
                  inProgress: state.inProgress,
                  fieldSize: state.fieldSize,
                  interval: state.interval,
                  cells: Game_model$ReactTemplate.toggle(state.cells, action[0]),
                  generation: 0
                };
      case /* SetFieldSize */2 :
          return {
                  inProgress: state.inProgress,
                  fieldSize: Math.max(5, action[0]),
                  interval: state.interval,
                  cells: state.cells,
                  generation: state.generation
                };
      case /* SetInterval */3 :
          return {
                  inProgress: state.inProgress,
                  fieldSize: state.fieldSize,
                  interval: Math.max(50, action[0]),
                  cells: state.cells,
                  generation: state.generation
                };
      
    }
  }
}

function useGame(param) {
  var match = React.useReducer(reducer, {
        inProgress: false,
        fieldSize: 25,
        interval: 300,
        cells: [[]],
        generation: 0
      }, (function (__x) {
          return reducer(__x, /* Init */0);
        }));
  var state = match[0];
  var interval = state.interval;
  var inProgress = state.inProgress;
  var dispatch = match[1];
  React.useEffect((function () {
          if (inProgress) {
            var tid = setInterval((function (param) {
                    return Curry._1(dispatch, /* Evolve */2);
                  }), interval);
            return (function (param) {
                      clearInterval(tid);
                      return /* () */0;
                    });
          }
          
        }), /* tuple */[
        inProgress,
        interval
      ]);
  return /* tuple */[
          state,
          dispatch
        ];
}

function Game(Props) {
  var match = useGame(/* () */0);
  var dispatch = match[1];
  var match$1 = match[0];
  var inProgress = match$1.inProgress;
  return React.createElement("div", undefined, React.createElement("h2", undefined, "Generation: " + (String(match$1.generation) + "")), React.createElement(Matrix$ReactTemplate.make, {
                  value: match$1.cells,
                  style: (function (param, state) {
                      return {
                              background: state ? "#357720" : "#bdbdbd"
                            };
                    }),
                  onCellClick: (function (param, coords, param$1) {
                      return Curry._1(dispatch, /* ToggleCell */Block.__(1, [coords]));
                    })
                }), React.createElement("p", undefined, React.createElement("button", {
                      onClick: (function (param) {
                          Curry._1(dispatch, /* ToggleGame */Block.__(0, [false]));
                          return Curry._1(dispatch, /* Evolve */2);
                        })
                    }, "Evolve"), React.createElement("button", {
                      onClick: (function (param) {
                          return Curry._1(dispatch, /* ToggleGame */Block.__(0, [!inProgress]));
                        })
                    }, inProgress ? "Pause" : "Start"), React.createElement("button", {
                      onClick: (function (param) {
                          return Curry._1(dispatch, /* Init */0);
                        })
                    }, "Random"), React.createElement("button", {
                      onClick: (function (param) {
                          return Curry._1(dispatch, /* Clear */1);
                        })
                    }, "Clear")), React.createElement("p", undefined, React.createElement("label", undefined, "Field size: ", React.createElement("input", {
                          max: "50",
                          min: 5,
                          type: "number",
                          value: String(match$1.fieldSize),
                          onChange: (function (_event) {
                              Curry._1(dispatch, /* SetFieldSize */Block.__(2, [_event.target.value]));
                              return Curry._1(dispatch, /* Init */0);
                            })
                        })), React.createElement("label", undefined, "Interval: ", React.createElement("input", {
                          max: "5000",
                          min: 50,
                          type: "number",
                          value: String(match$1.interval),
                          onChange: (function (_event) {
                              return Curry._1(dispatch, /* SetInterval */Block.__(3, [_event.target.value]));
                            })
                        }))));
}

var make = Game;

exports.colorByState = colorByState;
exports.reducer = reducer;
exports.useGame = useGame;
exports.make = make;
/* react Not a pure module */
